import { render } from "./PostsPage.vue?vue&type=template&id=6b9f5944&scoped=true"
import script from "./PostsPage.vue?vue&type=script&lang=js"
export * from "./PostsPage.vue?vue&type=script&lang=js"

import "./PostsPage.vue?vue&type=style&index=0&id=6b9f5944&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b9f5944"]])

export default __exports__